import BpkSectionHeader from '@skyscanner-internal/backpack-web/bpk-component-section-header';

import CardRail from '../CardRail';
import ThemeCard from '../ThemeCard';
import { useMBDContext } from '../common/MBD/useMBDContext';

import type { CityBreaksProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/hotels-components/CityBreaks';

const CityBreaks = ({ cards, description, id, title }: CityBreaksProps) => {
  const { buildMBDParam, rawComponentName } = useMBDContext();
  const trackingElementId = id || rawComponentName;

  if (!cards?.length) {
    return null;
  }

  return (
    <div
      className="CityBreaks"
      data-tracking-element-id={trackingElementId}
      data-tracking-common-params={buildMBDParam(trackingElementId)}
    >
      <BpkSectionHeader title={title} description={description} />
      <CardRail bottomNav>
        {(layout) =>
          cards.map((card, index) => (
            <ThemeCard
              key={card.title}
              {...card}
              index={`${layout}_${index}`}
            />
          ))
        }
      </CardRail>
    </div>
  );
};

export default CityBreaks;
